enum TransportStatus {
	OPEN = 'open',
	OPERATIONAL_CLOSED = 'operational_closed',
	CLOSED = 'closed',
	CHECKED = 'checked'
}

export default TransportStatus
